import { ICONS } from '../../common/constants'
import Button from './Button'
import InlineStack from './InlineStack'

// Wraps a list item for useMoveMode. Without `move` it renders a plain div.
export default function MoveItem({ move, index, className, children }) {
    if (!move) {
        return <div className={className}>{children}</div>
    }

    const {
        isMoving,
        isPressing,
        isDragging,
        isTargetBefore,
        isTargetAfter,
        offsetY,
    } = move.getItemState(index)

    let slotClassName = 'move-item-slot'
    if (isDragging) slotClassName += ' is-origin'
    if (isTargetBefore) slotClassName += ' is-target-before'
    if (isTargetAfter) slotClassName += ' is-target-after'

    let itemClassName = 'move-item'
    if (className) itemClassName += ` ${className}`
    if (move.isActive) itemClassName += ' move-mode'
    if (isMoving) itemClassName += ' is-moving'
    if (isPressing) itemClassName += ' is-pressing'
    if (isDragging) itemClassName += ' is-dragging'

    return (
        <div className={slotClassName}>
            <div
                className={itemClassName}
                style={
                    isDragging
                        ? { transform: `translateY(${offsetY}px)` }
                        : undefined
                }
                {...move.getItemProps(index)}
            >
                {move.isActive && (
                    <InlineStack spaceBetween itemsCenter gap="sm" wrap>
                        <div
                            className="move-handle"
                            title="Drag to move"
                            {...move.getHandleProps(index)}
                        >
                            <img
                                src={ICONS.DRAG_WHITE}
                                alt="drag"
                                width={16}
                                height={16}
                            />
                        </div>
                        {isMoving && (
                            <InlineStack gap="tiny" wrap>
                                <Button
                                    text="Top"
                                    type="button"
                                    tiny
                                    outline
                                    noMargin
                                    disabled={index === 0}
                                    onClick={move.moveToTop}
                                />
                                <Button
                                    text="Up"
                                    type="button"
                                    tiny
                                    outline
                                    noMargin
                                    disabled={index === 0}
                                    onClick={move.moveUp}
                                />
                                <Button
                                    text="Down"
                                    type="button"
                                    tiny
                                    outline
                                    noMargin
                                    disabled={index === move.count - 1}
                                    onClick={move.moveDown}
                                />
                                <Button
                                    text="Bottom"
                                    type="button"
                                    tiny
                                    outline
                                    noMargin
                                    disabled={index === move.count - 1}
                                    onClick={move.moveToBottom}
                                />
                                <Button
                                    text="Done"
                                    type="button"
                                    tiny
                                    noMargin
                                    onClick={move.stopMove}
                                />
                            </InlineStack>
                        )}
                    </InlineStack>
                )}
                {children}
            </div>
        </div>
    )
}
